import {
  Box,
  Text,
  ThemeColors,
  getThemeColor,
  getThemeSpacing,
} from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Card = styled(Box)`
  width: 100%;
  padding: ${({ theme }) => getThemeSpacing(3, theme)};
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};
  border-radius: ${({ theme }) => theme.border_radius.card};
  box-shadow: ${({ theme }) => theme.box_shadow.card};
  gap: ${({ theme }) => getThemeSpacing(3, theme)};
  background-color: ${({ theme }) => getThemeColor('white', theme)};
`

export const IconContainer = styled(Box)`
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => getThemeColor('grey_5', theme)};
  border-radius: 10px;
  box-shadow: ${({ theme }) => theme.box_shadow.card};
`

export const BigNumber = styled(Text)`
  & p {
    font-size: 36px;
    font-weight: 500;
  }
`

export const MediumNumber = styled(Text)`
  & p {
    font-size: 26px;
    font-weight: 500;
  }
`

export const ColoredBox = styled(Box)<{ color: ThemeColors }>`
  width: 16px;
  height: 16px;
  border-radius: 4px;
  background-color: ${({ color, theme }) => getThemeColor(color, theme)};
`
